// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"J4-z"};